/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProductResponseDto } from './productResponseDto';

export interface BranchCostAppraisalProductResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  price: number;
  latestPrice: number;
  priceDifference: number;
  priceChangeDirection: BranchCostAppraisalProductResponseDto.PriceChangeDirectionEnum;
  productPurchaseStatus: BranchCostAppraisalProductResponseDto.ProductPurchaseStatusEnum;
  product: ProductResponseDto;
}
// tslint:disable-next-line:no-namespace
export namespace BranchCostAppraisalProductResponseDto {
  export type PriceChangeDirectionEnum = 'up' | 'down' | 'no_change' | 'change_to_no_buy' | 'change_to_buy' | 'change_to_buy_up' | 'change_to_buy_down';
  export const PriceChangeDirectionEnum = {
      Up: 'up' as PriceChangeDirectionEnum,
      Down: 'down' as PriceChangeDirectionEnum,
      NoChange: 'no_change' as PriceChangeDirectionEnum,
      ChangeToNoBuy: 'change_to_no_buy' as PriceChangeDirectionEnum,
      ChangeToBuy: 'change_to_buy' as PriceChangeDirectionEnum,
      ChangeToBuyUp: 'change_to_buy_up' as PriceChangeDirectionEnum,
      ChangeToBuyDown: 'change_to_buy_down' as PriceChangeDirectionEnum,
  };
  export type ProductPurchaseStatusEnum = 'buy' | 'no_buy';
  export const ProductPurchaseStatusEnum = {
      Buy: 'buy' as ProductPurchaseStatusEnum,
      NoBuy: 'no_buy' as ProductPurchaseStatusEnum,
  };
}
